export { ResponsiveText } from './ResponsiveText';
